module.exports = __webpack_public_path__ + "img/avatar-default.5c21c3fb.png";